import api from './api';

const microbiologyService = {
  // Masters: Organisms
  getOrganismGroups: async (isActive = null) => {
    const params = isActive !== null ? { isActive } : {};
    const res = await api.get('/MicrobiologyMasters/organism-groups', { params });
    return res.data;
  },

  getOrganisms: async (params = {}) => {
    const res = await api.get('/MicrobiologyMasters/organisms', { params });
    return res.data;
  },

  getOrganismById: async (id) => {
    const res = await api.get(`/MicrobiologyMasters/organisms/${id}`);
    return res.data;
  },

  saveOrganism: async (data) => {
    const res = await api.post('/MicrobiologyMasters/organisms', data);
    return res.data;
  },

  // Masters: Antimicrobials
  getAntimicrobialClasses: async (isActive = null) => {
    const params = isActive !== null ? { isActive } : {};
    const res = await api.get('/MicrobiologyMasters/antimicrobial-classes', { params });
    return res.data;
  },

  getAntimicrobials: async (params = {}) => {
    const res = await api.get('/MicrobiologyMasters/antimicrobials', { params });
    return res.data;
  },

  getAntimicrobialById: async (id) => {
    const res = await api.get(`/MicrobiologyMasters/antimicrobials/${id}`);
    return res.data;
  },

  saveAntimicrobial: async (data) => {
    const res = await api.post('/MicrobiologyMasters/antimicrobials', data);
    return res.data;
  },

  // Masters: Specimens & Methods
  getSpecimens: async (isActive = null) => {
    const params = isActive !== null ? { isActive } : {};
    const res = await api.get('/MicrobiologyMasters/specimens', { params });
    return res.data;
  },

  saveSpecimen: async (data) => {
    const res = await api.post('/MicrobiologyMasters/specimens', data);
    return res.data;
  },

  getCultureMethods: async (isActive = null) => {
    const params = isActive !== null ? { isActive } : {};
    const res = await api.get('/MicrobiologyMasters/culture-methods', { params });
    return res.data;
  },

  getASTMethods: async (isActive = null) => {
    const params = isActive !== null ? { isActive } : {};
    const res = await api.get('/MicrobiologyMasters/ast-methods', { params });
    return res.data;
  },

  // Masters: Standards & Breakpoints
  getStandards: async () => {
    const res = await api.get('/MicrobiologyMasters/standards');
    return res.data;
  },

  getBreakpoints: async (params = {}) => {
    const res = await api.get('/MicrobiologyMasters/breakpoints', { params });
    return res.data;
  },

  saveBreakpoint: async (data) => {
    const res = await api.post('/MicrobiologyMasters/breakpoints', data);
    return res.data;
  },

  // Masters: Panels
  getASTPanels: async (params = {}) => {
    const res = await api.get('/MicrobiologyMasters/panels', { params });
    return res.data;
  },

  getASTPanelById: async (id) => {
    const res = await api.get(`/MicrobiologyMasters/panels/${id}`);
    return res.data;
  },

  getPanelForOrganismAndSpecimen: async (organismId, organismGroupId, specimenId) => {
    const res = await api.get('/MicrobiologyMasters/panels/lookup', {
      params: { organismId, organismGroupId, specimenId }
    });
    return res.data;
  },

  saveASTPanel: async (data) => {
    const res = await api.post('/MicrobiologyMasters/panels', data);
    return res.data;
  },

  // Masters: Resistance & Expert Rules
  getResistanceMechanisms: async (isActive = null) => {
    const params = isActive !== null ? { isActive } : {};
    const res = await api.get('/MicrobiologyMasters/resistance-mechanisms', { params });
    return res.data;
  },

  saveResistanceMechanism: async (data) => {
    const res = await api.post('/MicrobiologyMasters/resistance-mechanisms', data);
    return res.data;
  },

  getExpertRules: async (isActive = null) => {
    const params = isActive !== null ? { isActive } : {};
    const res = await api.get('/MicrobiologyMasters/expert-rules', { params });
    return res.data;
  },

  saveExpertRule: async (data) => {
    const res = await api.post('/MicrobiologyMasters/expert-rules', data);
    return res.data;
  },

  getCommentTemplates: async (category = null) => {
    const params = category ? { category } : {};
    const res = await api.get('/MicrobiologyMasters/comment-templates', { params });
    return res.data;
  },

  saveCommentTemplate: async (data) => {
    const res = await api.post('/MicrobiologyMasters/comment-templates', data);
    return res.data;
  },

  // Workbench Actions
  getWorklist: async (params = {}) => {
    const res = await api.get('/MicrobiologyWorkbench/worklist', { params });
    return res.data;
  },

  getWorkbenchDetail: async (testId) => {
    const res = await api.get(`/MicrobiologyWorkbench/${testId}`);
    return res.data;
  },

  saveCultureStatus: async (data) => {
    const res = await api.post('/MicrobiologyWorkbench/culture-status', data);
    return res.data;
  },

  saveMicroscopy: async (data) => {
    const res = await api.post('/MicrobiologyWorkbench/microscopy', data);
    return res.data;
  },

  saveIsolate: async (data) => {
    const res = await api.post('/MicrobiologyWorkbench/isolates', data);
    return res.data;
  },

  deleteIsolate: async (isolateId) => {
    const res = await api.delete(`/MicrobiologyWorkbench/isolates/${isolateId}`);
    return res.data;
  },

  calculateAST: async (data) => {
    const res = await api.post('/MicrobiologyWorkbench/ast/calculate', data);
    return res.data;
  },

  saveASTGrid: async (data) => {
    const res = await api.post('/MicrobiologyWorkbench/ast/save', data);
    return res.data;
  },

  saveResistanceFindings: async (data) => {
    const res = await api.post('/MicrobiologyWorkbench/resistance', data);
    return res.data;
  },

  overrideASTResult: async (data) => {
    const res = await api.post('/MicrobiologyWorkbench/override', data);
    return res.data;
  },

  releaseReport: async (data) => {
    const res = await api.post('/MicrobiologyWorkbench/reports/release', data);
    return res.data;
  },

  getReportVersions: async (cultureId) => {
    const res = await api.get(`/MicrobiologyWorkbench/reports/${cultureId}/versions`);
    return res.data;
  },

  getAntibiogram: async (params = {}) => {
    const res = await api.get('/MicrobiologyWorkbench/antibiogram', { params });
    return res.data;
  },

  // QC & Lot Management
  getQCLots: async (itemType = null) => {
    const params = itemType ? { itemType } : {};
    const res = await api.get('/MicrobiologyMasters/qc/lots', { params });
    return res.data;
  },

  saveQCLot: async (data) => {
    const res = await api.post('/MicrobiologyMasters/qc/lots', data);
    return res.data;
  },

  getQCRuns: async (params = {}) => {
    const res = await api.get('/MicrobiologyMasters/qc/runs', { params });
    return res.data;
  },

  recordQCRun: async (data) => {
    const res = await api.post('/MicrobiologyMasters/qc/runs', data);
    return res.data;
  },

  getQCExpectedRanges: async (atccStrainName = null) => {
    const params = atccStrainName ? { atccStrainName } : {};
    const res = await api.get('/MicrobiologyMasters/qc/expected-ranges', { params });
    return res.data;
  },

  saveQCExpectedRange: async (data) => {
    const res = await api.post('/MicrobiologyMasters/qc/expected-ranges', data);
    return res.data;
  },

  // Lab Configuration (Basic / Full mode)
  getLabConfig: async () => {
    const res = await api.get('/MicrobiologyMasters/lab-config');
    return res.data;
  },

  saveLabConfig: async (labMode) => {
    const res = await api.put('/MicrobiologyMasters/lab-config', { labMode });
    return res.data;
  },

  // Barcode & Label Configuration
  getBarcodeRules: async (params = {}) => {
    const res = await api.get('/MicrobiologyMasters/barcodes', { params });
    return res.data;
  },

  getBarcodeRuleById: async (id) => {
    const res = await api.get(`/MicrobiologyMasters/barcodes/${id}`);
    return res.data;
  },

  saveBarcodeRule: async (data) => {
    const res = await api.post('/MicrobiologyMasters/barcodes', data);
    return res.data;
  },

  // Record Retention & Archival Policies
  getRetentionPolicies: async (params = {}) => {
    const res = await api.get('/MicrobiologyMasters/retention', { params });
    return res.data;
  },

  getRetentionPolicyById: async (id) => {
    const res = await api.get(`/MicrobiologyMasters/retention/${id}`);
    return res.data;
  },

  saveRetentionPolicy: async (data) => {
    const res = await api.post('/MicrobiologyMasters/retention', data);
    return res.data;
  },

  executeDisposal: async (data) => {
    const res = await api.post('/MicrobiologyMasters/retention/dispose', data);
    return res.data;
  }
};

export default microbiologyService;
